import { api as axios } from "../../../../shared/axios";
import useSWR from "swr";
import { API_URL } from "../../../../shared/config";

const fetcher = (url) => axios.get(url);

export const useGetGeneralFactSheet = (companyId, year) => {
  const { data, error, mutate } = useSWR(
    `${API_URL}/data-source/fact-sheet/general-source/?company_id=${companyId}&year=${year}`,
    fetcher,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: true,
      dedupingInterval: 9_00_00,
    }
  );
  return {
    dataGeneralFactSheet: data?.data,
    isLoadingDataGeneralFactSheet: !error && !data,
    isErrorDataGeneralFactSheet: error,
    mutateGeneralFactSheet: mutate,
  };
};

export const createGeneralFactSheet = async (payload) => {
  const formData = new FormData();
  if (payload.company_id) {
    formData.append("company_id", payload.company_id);
  }

  if (payload.year) {
    formData.append("year", payload.year);
  }

  if (payload.logo) {
    Object.entries(payload).forEach(([k, v]) => {
      if (["logo"].includes(k)) {
        for (const file of v ?? []) {
          if (file instanceof File) {
            formData.append("org_logo", file, file.name);
          } else {
            formData.append("org_logo", file);
          }
        }
      }
    });
  }

  if (payload.data) {
    formData.append("data", JSON.stringify(payload.data));
  }

  try {
    const request = await axios.post(
      `${API_URL}/data-source/fact-sheet/general-source/`,
      formData,
      {
        headers: {
          "Content-Type": undefined,
        },
      }
    );
    return { data: request.data, error: undefined };
  } catch (error) {
    return { data: undefined, error: error };
  }
};

export const useGetCfoReportFactSheet = (companyId, year) => {
  const { data, error, mutate } = useSWR(
    `${API_URL}/data-source/fact-sheet/cfo/?company_id=${companyId}&year=${year}`,
    fetcher,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: true,
      dedupingInterval: 9_00_00,
    }
  );
  return {
    dataCfoReportFactSheet: data?.data,
    isLoadingDataCfoReportFactSheet: !error && !data,
    isErrorDataCfoReportFactSheet: error,
    mutateCfoReportFactSheet: mutate,
  };
};

export const createCfoReportFactSheet = async (payload) => {
  const formData = new FormData();
  if (payload.company_id) {
    formData.append("company_id", payload.company_id);
  }

  if (payload.year) {
    formData.append("year", payload.year);
  }

  if (payload.org_chart || payload.org_scope_doc) {
    Object.entries(payload).forEach(([k, v]) => {
      if (["org_chart", "org_scope_doc"].includes(k)) {
        for (const file of v ?? []) {
          if (file instanceof File) {
            formData.append(k, file, file.name);
          }
          //    else {
          //     formData.append(k, file);
          //   }
        }
      }
    });
  }

  if (payload.data) {
    formData.append("data", JSON.stringify(payload.data));
  }

  if (payload.del_image_ids && payload.del_image_ids.length > 0) {
    formData.append("del_image_ids", JSON.stringify(payload.del_image_ids));
  }

  try {
    const request = await axios.post(
      `${API_URL}/data-source/fact-sheet/cfo/`,
      formData,
      {
        headers: {
          "Content-Type": undefined,
        },
      }
    );
    return { data: request.data, error: undefined };
  } catch (error) {
    return { data: undefined, error: error };
  }
};
